import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { ProductRequestType } from '../../types';

@Component({
  selector: 'lp-product-request-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpProductRequestViewComponent extends BaseResizableComponent {
  @Input() data?: ProductRequestType | null;
  @Input() loading = false;
}
